import { createEntityComboBox } from './helpers/createEntityComboBox';

import { createQueryHook } from '~/shared/providers/api';
import { QueryHookResult } from '~/shared/providers/api/createQueryHook';

export type SelectableContainerType = QueryHookResult<
  typeof useContainerTypesQuery
>[number];

const useContainerTypesQuery = createQueryHook(
  'shared.selectContainerType',
  (params: { ids?: string[]; searchTerm?: string }) => ({
    containerTypes: {
      __args: {
        filter: {
          ids: params.ids,
          searchTerm: params.searchTerm,
        },
        pagination: {
          limit: 1000,
          offset: 0,
        },
      },
      entries: {
        id: true,
        name: true,
      },
    },
  }),
  {
    select: (data) =>
      data?.containerTypes.entries.map((entry) => ({
        id: entry.id,
        name: entry.name,
      })) ?? [],
  },
);

export const SelectContainerType = createEntityComboBox.remotelySearched(
  'SelectContainerType',
  useContainerTypesQuery,
  {
    formatLabel: (entity) => entity.name,
  },
);
